import _t from 'i18n!nls/account-profile';

export type ExternalLinks = {
  default?: string | null;
  facebook?: string | null;
  github?: string | null;
  gplus?: string | null;
  linkedin?: string | null;
  twitter?: string | null;
  resume?: string | null;
};

export type ExternalLinksOption = {
  id: string;
  index: number;
  inputName: string;
  visibleLabel: string;
  value?: string | null;
  placeholder?: string;
};

const GOOGLE_DRIVE_HOSTNAME = 'drive.google.com';
const ONE_DRIVE_HOSTNAME = 'onedrive.com';
const ONE_DRIVE_LIVE_HOSTNAME = 'onedrive.live.com';
const ONE_DRIVE_SHORTENED_HOSTNAME = '1drv.ms';
const UPLOADS_BUCKET_HOSTNAME = 'coursera-profile-resumes.s3.amazonaws.com';

export const formatWebsiteData = (data: ExternalLinksOption[]) => {
  const websites: Record<string, string | null | undefined> = {};
  if (data) {
    data.forEach((site) => {
      if (site && site.value) {
        websites[site.id] = site.value;
      }
    });
  }
  return websites;
};

export const getWebsitesData = (links: ExternalLinks, requestCountryCode: string) => {
  const linkedInData = {
    index: 0,
    id: 'linkedin',
    inputName: 'website_linkedin',
    value: links?.linkedin,
    visibleLabel: _t('LinkedIn'),
  };
  const facebookData = {
    index: 1,
    id: 'facebook',
    inputName: 'website_facebook',
    value: links?.facebook,
    visibleLabel: _t('Facebook'),
  };
  const twitterData = {
    index: 2,
    id: 'twitter',
    inputName: 'website_twitter',
    value: links?.twitter,
    visibleLabel: _t('Twitter'),
  };
  const githubData = {
    index: 3,
    id: 'github',
    inputName: 'website_github',
    value: links?.github,
    visibleLabel: _t('Github'),
  };
  const otherData = {
    index: 4,
    id: 'default',
    inputName: 'website',
    value: links?.default,
    visibleLabel: _t('Other'),
  };

  let websitesData;
  if (requestCountryCode === 'CN') {
    websitesData = [linkedInData, githubData, otherData];
  } else {
    websitesData = [linkedInData, facebookData, twitterData, githubData, otherData];
  }

  return websitesData;
};

export const isValidUrl = (url: string) => {
  try {
    return Boolean(new URL(url as string));
  } catch {
    return false;
  }
};

export const isValidResumeUrlSource = (url: string) => {
  try {
    const urlObj = new URL(url as string);

    const isHttpsProtocol = urlObj.protocol === 'https:';

    const isGoogleDriveLink = urlObj.hostname === GOOGLE_DRIVE_HOSTNAME;
    const isOneDriveLink =
      urlObj.hostname === ONE_DRIVE_HOSTNAME ||
      urlObj.hostname === ONE_DRIVE_LIVE_HOSTNAME ||
      urlObj.hostname === ONE_DRIVE_SHORTENED_HOSTNAME;
    const isUpload = urlObj.hostname === UPLOADS_BUCKET_HOSTNAME;

    const isValidResumeSource = isHttpsProtocol && (isUpload || isOneDriveLink || isGoogleDriveLink);

    return isValidResumeSource;
  } catch {
    return false;
  }
};

export const isUploadedResume = (url: string) => {
  try {
    const urlObj = new URL(url);
    const isHttpsProtocol = urlObj.protocol === 'https:';
    return isHttpsProtocol && urlObj.hostname === UPLOADS_BUCKET_HOSTNAME;
  } catch {
    return false;
  }
};
